module.exports = __webpack_public_path__ + "img/wuye2.7c13a80a.jpg";